import React from 'react';
import { Button } from '@/components/ui/button';
import { ChevronDown, Loader2 } from 'lucide-react';

interface LoadMoreButtonProps {
  onLoadMore: () => void;
  loading: boolean;
  hasMore: boolean;
}

const LoadMoreButton = ({ onLoadMore, loading, hasMore }: LoadMoreButtonProps) => {
  if (!hasMore) return null;

  return (
    <div className="flex justify-center py-8">
      <Button 
        onClick={onLoadMore}
        disabled={loading}
        variant="outline"
        className="flex items-center gap-2 min-w-[150px] group relative overflow-hidden border border-gray-300 dark:border-gray-600 hover:border-youtube-red dark:hover:border-youtube-red transition-all duration-300"
      >
        {loading ? (
          <>
            <Loader2 className="w-4 h-4 animate-spin" />
            Chargement...
          </>
        ) : (
          <>
            Voir plus
            <ChevronDown className="w-4 h-4 transition-transform group-hover:translate-y-1" />
          </>
        )}
      </Button>
    </div>
  );
};

export default LoadMoreButton;